// extracted by mini-css-extract-plugin
export var grid = "PartnersGrid-module--grid--30718";
export var partner = "PartnersGrid-module--partner--07f3e";
export var small = "PartnersGrid-module--small--a648f";